module.exports = __webpack_public_path__ + "img/capa-49.c46d9ac6.png";